<script lang="ts" setup>
import type { OperationModel } from "~/core/models/OperationModel.interface";
import { OperationModelType } from "~/core/models/OperationModelType.enum";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import { DtwinFormOperationListColumns } from "~/modules/dtwin/models/DtwinFormOperationListColumns.enum";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";

defineProps<{
  organizationCode: number;
  dtwin: Dtwin;
  dtwinModel: DtwinModel;
  dtwinOperationModel: OperationModel;
}>();

const emit = defineEmits(["edit"]);

const baseComponentRef = ref<
  (ComponentPublicInstance & { reload: () => Promise<void> | void }) | undefined
>();

const columns: DtwinFormOperationListColumns[] = [
  DtwinFormOperationListColumns.CREATED_AT,
  DtwinFormOperationListColumns.LAUNCHED_AT,
  DtwinFormOperationListColumns.MODIFIED_AT,
  DtwinFormOperationListColumns.STATUS,
];

function reloadWithContext() {
  baseComponentRef.value?.reload();
}

defineExpose({
  reload: reloadWithContext,
});
</script>

<template>
  <dtwin-form-operation
    ref="baseComponentRef"
    :organization-code="organizationCode"
    :dtwin="dtwin"
    :dtwin-model="dtwinModel"
    :dtwin-operation-model="dtwinOperationModel"
    :operation-type="OperationModelType.CERT_RENEW"
    :columns="columns"
    @edit="emit('edit', $event)"
  />
</template>
